import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import lipData from "../../data/lip"

class LearnInPublic extends React.Component {
  render() {
    return (
      <Layout hideFooter location={this.props.location} title={"Blog"}>
        <SEO title="Peter Elbaum | Learn in Public" />
        <h1>🤓 Learn in Public</h1>
        <p>I've curated a set of the most helpful resources I've found on strategies for learning in public. Let me know what else I should add!</p>
        <ul>
          {lipData.pageLinks.map((item, i) => {
            return (
              <li key={i}>
                  <a className="lip-link" href={item.link} rel="noreferrer" target="_blank">
                    {item.title}
                  </a>
              </li>
            )
          })}
        </ul>
      </Layout>
    )
  }
}

export default LearnInPublic
